import React from 'react';

import groupBy from 'lodash/groupBy';

import { IBRNRepairItemBasic } from '../../declarations';
import Divider from '../common/Divider';
import SellerResponseRepairItem from './SellerResponseRepairItem';

import './SellerResponseRepairItemsStyle.less';

export interface ISellerResponseRepairItemProps {
  brnRepairItems: IBRNRepairItemBasic[];
}

export default class SellerResponseRepairItems extends React.PureComponent<
  ISellerResponseRepairItemProps
> {
  public render(): JSX.Element {
    const { brnRepairItems } = this.props;

    const repairItemsGroupedByCategory: { [key: string]: IBRNRepairItemBasic[] } = groupBy(
      brnRepairItems,
      repairItem => (repairItem.label || 'Other').split('-')[0],
    );
    const repairItemCategories = Object.keys(repairItemsGroupedByCategory);
    const indexOfLastRepairItemCategory = repairItemCategories.length - 1;
    const indexOfLastRepairItem =
      repairItemsGroupedByCategory[repairItemCategories[indexOfLastRepairItemCategory]].length - 1;

    return (
      <div className="resale-closing-dashboard-seller-response-repair-items">
        {repairItemCategories.map((key, categoryIndex) => (
          <div className="repair-item-group" key={key}>
            <div className="repair-item-group-header">{key}</div>
            {repairItemsGroupedByCategory[key].map((repairItem, repairItemIndex) => (
              <div className="seller-response-repair-item-row" key={repairItem.id}>
                <SellerResponseRepairItem brnRepairItem={repairItem} />
                {(categoryIndex === indexOfLastRepairItemCategory &&
                  repairItemIndex === indexOfLastRepairItem) || <Divider />}
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  }
}
